<sc-paged-content [data]="data" [configuration]="configuration" (addRequested)="onAddRequested($event)" (selectionChanged)="onSelectionChanged($event)" [selected]="[currentVehicleArchive]">
  <sc-no-data-container [hasData]="currentVehicleArchive" fitHeight>
    <sc-flex vertical fitHeight stretchContent>
      <sc-flex [gap]="16">
        <sc-cancel-button (click)="cancelEditing()"></sc-cancel-button>
        <sc-save-button (click)="saveVehicleArchive()" primary></sc-save-button>
        <sc-delete-button (click)="onDeleteRequested($event)"></sc-delete-button>
      </sc-flex>
      <sc-content-spacer vertical></sc-content-spacer>
      <sc-flex-fitting-content vertical>
        <sc-scroll-pane>
          <sc-formular-component [model]="currentVehicleArchive" [context]="{layout: detailLayout!, detailLayoutItemProvider: detailLayoutItemProvider!}"></sc-formular-component>
        </sc-scroll-pane>
      </sc-flex-fitting-content>
    </sc-flex>
  </sc-no-data-container>
</sc-paged-content>
